import { useState, useEffect, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { Table, Button } from 'antd';
import axios from "./../../services/http";

const TablaDesglocePresupuestoPorID = ({ obra }) => {

    const navigate = useNavigate();
    const [presupuestos, setPresupuestos] = useState([]);
    const [buildersInfo, setBuildersInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const columns = [
        {
            title: 'ID',
            dataIndex: 'partida',
            key: 'partida'
        },
        // {
        //     title: 'Contratista',
        //     dataIndex: 'contratista',
        //     key: 'contratista',
        // },
        {
            title: 'Total Presupuesto',
            dataIndex: 'total',
            key: 'total',
            render: (text) => `$ ${numberFormat.format(text)}`
        },
        {
            title: 'Proyección cierre',
            dataIndex: 'proyeccion_cierre',
            key: 'proyeccion_cierre',
            render : (_, record) => {
                let { totalFiscal, totalNoFiscal, contratoFiscal, contratoNoFiscal, registradoFiscal, registradoNoFiscal } = record;
                let gastadoTotal = totalFiscal+totalNoFiscal;
                //console.log("gastadoTotal", gastadoTotal);

                //Pendiente Relacionar
                let restanteFiscal = contratoFiscal - registradoFiscal;
                let restanteNoFiscal = contratoNoFiscal - registradoNoFiscal;
                let pendienteRestante = restanteFiscal+restanteNoFiscal;
                //console.log("pendienteRestante", pendienteRestante);

                //Control de contratistas
                let { partida } = record;
                const builderData = buildersInfo.filter(item => item.partidas === partida);
                //console.log("builderData***", builderData, partida);

                let totalControlContratistas = 0;
                for (let i = 0; i < builderData.length; i++) totalControlContratistas += builderData[i]["totalRestante"];
                // let { presupuesto, presupuesto_iva, presupuesto_no_iva } = record;
                // const budgetIva = presupuesto * (presupuesto_iva/100);
                // let remainingIva = (budgetIva - totalFiscal);
                // const budgetNotIva = presupuesto * (presupuesto_no_iva / 100);
                // let remainingNotIva = (budgetNotIva - totalNoFiscal);

                //let controlContratistas = remainingIva+remainingNotIva;
                //console.log("controlContratistas", totalControlContratistas);

                return `$ ${numberFormat.format(gastadoTotal+pendienteRestante+totalControlContratistas)}`;
            }
        },
        {
            title: 'Gastado Total (Sin IVA)',
            dataIndex: 'cantidad',
            key: 'cantidad',
            render: (_, record) => {
                let { totalFiscal, totalNoFiscal } = record;
                return `$ ${numberFormat.format(totalFiscal+totalNoFiscal)}`;
            }
        },
        {
            title: 'Gastado Fiscal',
            dataIndex: 'gastadoFiscal',
            key: 'gastadoFiscal',
            render: (_, record) =>  {
                let { iva, totalFiscal } = record;
                let amountIva = (iva/100) * totalFiscal;
                return `$ ${numberFormat.format(amountIva+totalFiscal)}`
            }
        },
        {
            title: 'Gastado No Fiscal',
            dataIndex: 'totalNoFiscal',
            key: 'totalNoFiscal',
            render: (text) => `$ ${numberFormat.format(text)}`
        }
    ];

    useEffect(() => {
        fetchControlPresupuesto();
        ControlesContratitas();
    }, [obra]);

    const fetchControlPresupuesto = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/v1/relationship/control-budget/data/${obra.id}`);
            setPresupuestos(response);
        } catch (error) {
            console.error('Error al cargar las relaciones:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const ControlesContratitas = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/construction/cp/${obra.id}`);
            
            for(let i = 0; i < response.length; i++) {
                response[i]["total_nofiscal"] = 0;
                response[i]["total_fiscal"] = 0;
            }
            
            const responseTotal = await axios.HTTP_POST("/api/construction/count/amounts", { obraId: obra.id });
            
            if (responseTotal && responseTotal.data.length > 0) {
                for(let i = 0; i < response.length; i++) {
                    let relation = responseTotal.data.filter(item => item.partida === response[i].partidas && item.control_pago_id === response[i].id);
                    if (relation.length > 0) {
                        let noFiscal = relation.filter(item => item["tipo_monto"] === "No Fiscal");
                        let fiscal = relation.filter(item => item["tipo_monto"] === "Fiscal");
                        if (fiscal.length > 0) response[i]["total_fiscal"] = fiscal[0].Total;
                        if (noFiscal.length > 0) response[i]["total_nofiscal"] = noFiscal[0].Total;
                    }
                }

                for (let i = 0; i < response.length; i++) {
                    let { presupuesto, presupuesto_iva, presupuesto_no_iva, total_fiscal, total_nofiscal } = response[i];
                    const budgetIva = presupuesto * (presupuesto_iva/100);
                    let remainingIva = (budgetIva - total_fiscal);
                    const budgetNotIva = presupuesto * (presupuesto_no_iva / 100);
                    let remainingNotIva = (budgetNotIva - total_nofiscal);

                    //console.log("remainingIva***", remainingIva, partida);
                    response[i]["totalRestante"] = 0;
                    response[i]["totalRestante"] = remainingIva+remainingNotIva;
                    //console.log("builderData[i]['controlContr']", builderData[i]["controlContr"]);
                }
            }
            //console.log("buildersInfo", response);
            
            setBuildersInfo(response);

        } catch (error) {
            console.error('Error al cargar los controles de contratistas:', error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    const totals = useMemo(() => {
        let totalPresupuesto = 0, totalProyeccion = 0, totalGastado = 0, totalGastadoFiscal = 0, totalGastadoNoFiscal = 0;
        presupuestos.forEach((record) => {
            totalPresupuesto += record.total || 0;
            totalGastadoNoFiscal += record.totalNoFiscal || 0;
            let gastado = (record.totalFiscal || 0) + (record.totalNoFiscal || 0);
            totalGastado += gastado;
            let ivaVal = record.iva || 0;
            let amountIva = (ivaVal / 100) * (record.totalFiscal || 0);
            totalGastadoFiscal += amountIva + (record.totalFiscal || 0);
            let restanteFiscal = (record.contratoFiscal || 0) - (record.registradoFiscal || 0);
            let restanteNoFiscal = (record.contratoNoFiscal || 0) - (record.registradoNoFiscal || 0);
            let pendienteRestante = restanteFiscal + restanteNoFiscal;
            let builderData = buildersInfo.filter(item => item.partidas === record.partida);
            let totalCC = 0;
            for (let i = 0; i < builderData.length; i++) totalCC += builderData[i]["totalRestante"];
            totalProyeccion += gastado + pendienteRestante + totalCC;
        });
        return { totalPresupuesto, totalProyeccion, totalGastado, totalGastadoFiscal, totalGastadoNoFiscal };
    }, [presupuestos, buildersInfo]);

    return (
        <>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', padding: '12px 16px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 8, fontWeight: 'bold', fontSize: 13 }}>
                <span>TOTALES:</span>
                <span>Total Presupuesto: $ {numberFormat.format(totals.totalPresupuesto)}</span>
                <span>Proyección cierre: $ {numberFormat.format(totals.totalProyeccion)}</span>
                <span>Gastado Total: $ {numberFormat.format(totals.totalGastado)}</span>
                <span>Gastado Fiscal: $ {numberFormat.format(totals.totalGastadoFiscal)}</span>
                <span>Gastado No Fiscal: $ {numberFormat.format(totals.totalGastadoNoFiscal)}</span>
            </div>
            <Table
                dataSource={presupuestos}
                columns={columns}
                rowKey={record => record.partida}
                loading={loading}
                pagination={false}
            />
        </>
    )
}

export default TablaDesglocePresupuestoPorID;